export interface FormHostParameters {
    renderId: string; // this is an id that referrs to this specific execution.  this is needed to make sure we are closing the right form
    renderUI: () => JSX.Element;
    size?: { width: number; height: number };
    fullScreen?: boolean;
    allowClickAwayClose?: boolean;
    title?: string;
    showCloseButton?: boolean;
}

export interface IFormHost {
    renderUI(formData: FormHostParameters): void;

    // closes the ui if it is same one that is open
    close(renderId: string): void;
}

export class FormHost {
    private static _defaultFormHost: IFormHost | undefined;

    static get defaultFormHost(): IFormHost | undefined {
        return this._defaultFormHost;
    }

    static set defaultFormHost(formHost: IFormHost | undefined) {
        this._defaultFormHost = formHost;
    }
}
